/**
 * @flow
 * @author: Pavan
 */

import React, { Component } from 'react'
// import MediaQuery from 'react-responsive'
import queryString from 'query-string'
import BaseModalContainer from '../../commons/BaseModalContainer'
import TermsAndConditionsModal from '../../components/TermsAndConditionsModal'
import CloseModalIcon from '../../components/Icons/CloseModalIcon'
import PunePageResponsiveContainer from '../core/PunePageResponsiveContainer'
import FormDropdown from '../IbcArcade/FormDropdown'
import { getRandomBookingSlotId } from '../../utils/AppUtils'
import { scrollToFaqSection } from '../../utils/navigationUtils'
import { replaceSpacesAndHypensInString } from '../../utils/StringUtils'
import { IcSmartPhone, IcUser, IcClose } from '../../Icons'
import {
  validateFullName,
  validateMobileNumber,
  validateEmailOrMobileNumber
} from '../../utils/FormValidations'
import { submitForm } from '../../utils/forms.js'
import Colors from '../../themes/Colors'
import frmConstants, {
  NO_OF_PEOPLE,
  PREFERRED_DATE,
  BOOK_NOW_BUTTON,
  KOLKATA_BHOWANIPORE
} from './constants'
import DateField from './DateField'

import TermsAndConditions from './TermsAndConditions'

import {
  FormMobileMainContainer,
  MainMdContainer,
  FormMdContainer,
  SubmitBtnContainer,
  Divider,
  InputContainer,
  FormContainer,
  MainContainer,
  SubmitButton,
  LabelText,
  ButtonLabel,
  ButtonWrapper,
  ButtonIconContainer,
  MdDesktop,
  Desktop,
  Mobile,
  Separator,
  CloseIconWrapper,
  IconContainer,
  TnCContainer,
  TandCApplyText,
  TandCTextContainer,
  TandCTextInnerContainer,
  ArrowIcon,
  ButtonContainer,
  ButtonText,
  FaqButton,
  FaqText
} from './styledComponents'
import styles from './styles'
import '../../assets/css/react-datepicker-overrides.css'
import 'react-datepicker/dist/react-datepicker.css' // eslint-disable-line

type Props = {
  formConstants: Object,
  onFormSubmitSuccess: () => void
}

const iconWidth = 14
const iconHeight = 14
class FormHomePage extends Component<Props> {
  static defaultProps = {
    formConstants: frmConstants,
    onFormSubmitSuccess: () => {},
    slotIdLength: 5,
    chars: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    slotIdPrefix: 'iBCPUNE',
    arcadeFormMauticID: 26
  }

  state = {
    parsedQueryParams: false
  }

  renderTermsAndConditions = () => {
    const { showFaq } = this.props
    return (
      <TandCTextContainer showFaq={showFaq}>
        {showFaq ? (
          <FaqButton id="new-landing-faqs-button">
            <FaqText onClick={scrollToFaqSection}>{'FAQs'}</FaqText>
          </FaqButton>
        ) : null}
        <TandCTextInnerContainer id={`terms-and-conditions-container`}>
          <TandCApplyText
            id={`terms-and-conditions-text`}
            onClick={this.openTnCModal}
          >
            *T&C apply
          </TandCApplyText>
        </TandCTextInnerContainer>
      </TandCTextContainer>
    )
  }

  validateAllFields = (dateRef, nameRef, mobileRef, dropdownRef) => {
    // DateFieldValidation
    const validationResponse = dateRef.validate()
    const isValidDateField = !validationResponse.displayError
    // NameFieldValidation
    const nameValidationResponse = nameRef.validate()
    const isValidNameField = !nameValidationResponse.displayError
    // MobileFieldValidation
    const mobileValidationResponse = mobileRef.validate()
    const isValidMobileNumberField = !mobileValidationResponse.displayError

    // DropdownFieldValidation
    dropdownRef.validateDropDownValue()
    const isValidDropdownField = !dropdownRef.state.displayError

    return (
      isValidDateField &&
      isValidNameField &&
      isValidMobileNumberField &&
      isValidDropdownField
    )
  }

  getFormData = (
    dateRef,
    nameRef,
    mobileRef,
    dropdownRef,
    packageDropdownRef,
    slotIdLength,
    chars,
    slotIdPrefix
  ) => {
    const commonRequestObject = {
      slotId: getRandomBookingSlotId(slotIdLength, chars, slotIdPrefix),
      name: nameRef.state.value,
      mobileNumber: mobileRef.state.value,
      noOfPeople: dropdownRef.state.dropdownValue,
      dateOfBooking: dateRef.dateFieldInstance.state.dateValue
    }
    if (this.isBhowaniporePresentInQueryParams()) {
      return {
        ...commonRequestObject,
        package: packageDropdownRef.state.dropdownValue
      }
    } else if (this.props.isOnePlusOneOfferPresentInPriceCards) {
      return {
        ...commonRequestObject,
        offers: '1+1 rcb offer'
      }
    }
    return commonRequestObject
  }

  prepareRequestObject = (formData, arcadeCity) => ({
    slot_unique_id: formData.slotId,
    date_of_slot:
      formData.dateOfBooking !== '' &&
      formData.dateOfBooking.format('DD MM YYYY, h:mm a'),
    f_name: formData.name,
    phone_number: formData.mobileNumber,
    no_of_people_attending: formData.noOfPeople,
    package: formData.package,
    offers: formData.offers,
    arcade_name: arcadeCity
  })
  onFailureSubmitForm = () => {
    // TODO: Need to ask for UI to design team: @dependency on Anesh,Design
    // alert('Form Submission Failed! Try again!') //eslint-disable-line
  }

  trackUser = () => {
    if (typeof fbq === 'function') {
      // this is for tracking analytics in fb
      fbq('track', 'iBCricketBookingSuccess', {}) // eslint-disable-line
    }
  }

  handleSubmitFn = (
    dateRef,
    nameRef,
    mobileRef,
    dropdownRef,
    packageDropdownRef
  ) => {
    // Do validation

    const isValidForm = this.validateAllFields(
      dateRef,
      nameRef,
      mobileRef,
      dropdownRef
    )

    if (isValidForm) {
      // do submit with mautic
      const {
        onFormSubmitSuccess,
        slotIdLength,
        chars,
        slotIdPrefix,
        arcadeFormMauticID,
        arcadeCity
      } = this.props
      const formData = this.getFormData(
        dateRef,
        nameRef,
        mobileRef,
        dropdownRef,
        packageDropdownRef,
        slotIdLength,
        chars,
        slotIdPrefix
      )

      const prepareRequestObject = this.prepareRequestObject(
        formData,
        arcadeCity
      )
      submitForm(
        prepareRequestObject,
        arcadeFormMauticID,
        'iBCPuneArcadeSlotBooking',
        this.trackUser,
        () => {},
        this.onFailureSubmitForm
      )
      onFormSubmitSuccess(formData)
    }
  }
  captureDateRef = ref => {
    this.dateField = ref
  }
  captureDropdownRef = ref => {
    this.dropdownRef = ref
  }
  capturePackageDropdownRef = ref => {
    this.packageDropdownRef = ref
  }
  captureModalRef = ref => {
    if (ref) {
      this.modalRef = ref
    }
  }
  openModal = () => {
    if (this.modalRef) {
      this.modalRef.openModal()
    }
  }
  closeModal = () => {
    if (this.modalRef) {
      this.modalRef.closeModal()
    }
  }
  captureTnCModalRef = ref => {
    if (ref) {
      this.tncModalRef = ref
    }
  }
  openTnCModal = () => {
    if (this.tncModalRef) {
      this.tncModalRef.openTnCModal()
    }
  }
  closeTnCModal = () => {
    if (this.tncModalRef) {
      this.tncModalRef.closeTnCModal()
    }
  }
  storeFullNameRef = ref => {
    this.usernameRef = ref
  }
  storeMobileNumberRef = ref => {
    this.mobileNumberRef = ref
  }

  storeDesktopFullNameRef = ref => {
    this.desktopNameRef = ref
  }
  storeDesktopMobileNumberRef = ref => {
    this.desktopMobileNumberRef = ref
  }

  captureDesktopDateRef = ref => {
    this.desktopDateField = ref
  }
  captureDesktopDropdownRef = ref => {
    this.desktopDropdownRef = ref
  }

  capturePackageDesktopDropdownRef = ref => {
    this.desktopPackageDropdownRef = ref
  }

  resetForm = () => {
    if (this.desktopNameRef) {
      this.desktopNameRef.reset()
    }

    if (this.usernameRef) {
      this.usernameRef.reset()
    }
    if (this.mdDesktopNameRef) {
      this.mdDesktopNameRef.reset()
    }

    if (this.desktopMobileNumberRef) {
      this.desktopMobileNumberRef.reset()
    }
    if (this.mdDesktopMobileNumberRef) {
      this.mdDesktopMobileNumberRef.reset()
    }
    if (this.mobileNumberRef) {
      this.mobileNumberRef.reset()
    }
    if (this.desktopDropdownRef) {
      this.desktopDropdownRef.reset()
    }
    if (this.desktopPackageDropdownRef) {
      this.desktopPackageDropdownRef.reset()
    }
    if (this.mdDesktopDropdownRef) {
      this.mdDesktopDropdownRef.reset()
    }
    if (this.mdDesktopPackageDropdownRef) {
      this.mdDesktopPackageDropdownRef.reset()
    }
    if (this.dropdownRef) {
      this.dropdownRef.reset()
    }
    if (this.packageDropdownRef) {
      this.packageDropdownRef.reset()
    }
    if (this.mdDesktopDateField) {
      this.mdDesktopDateField.reset()
    }
    if (this.desktopDateField) {
      this.desktopDateField.reset()
    }
    if (this.dateField) {
      this.dateField.reset()
    }
  }
  storeMdDesktopFullNameRef = ref => {
    this.mdDesktopNameRef = ref
  }
  storeMdDesktopMobileNumberRef = ref => {
    this.mdDesktopMobileNumberRef = ref
  }

  captureMdDesktopDateRef = ref => {
    this.mdDesktopDateField = ref
  }
  captureMdDesktopDropdownRef = ref => {
    this.mdDesktopDropdownRef = ref
  }

  captureMdDesktopPackageDropdownRef = ref => {
    this.mdDesktopPackageDropdownRef = ref
  }

  replaceSpacesAndHypensInStringAndConvertToLowerCase = srcString =>
    replaceSpacesAndHypensInString(srcString).toLowerCase()

  queryParams = { arcades: '' }
  isBhowaniporePresentInQueryParams = () =>
    this.queryParams.arcades === 'bhowanipore'

  renderMdDesktop = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
      if (this.state.parsedQueryParams === false)
        this.setState({ parsedQueryParams: true })
    }
    const { formConstants, termsAndConditionsData, excludeDates } = this.props
    const {
      dateField,
      submitBtnText,
      nameField,
      mobileNumberField,
      mobileNumberOrEMailField,
      packageField
    } = formConstants
    const { dropDownValues, label } = packageField
    return (
      this.state.parsedQueryParams && (
        <MdDesktop>
          <MainMdContainer id="slot-booking-main-container">
            <FormMdContainer id="slot-booking-form-container">
              <InputContainer
                id={this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                  nameField.label
                )}
                isMobile={false}
                innerRef={this.storeMdDesktopFullNameRef}
                label={nameField.label}
                placeholder={nameField.placeholderText}
                icon={IcUser}
                validate={validateFullName}
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              <Separator
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              <InputContainer
                id={
                  this.queryParams.arcades === KOLKATA_BHOWANIPORE
                    ? this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                        mobileNumberOrEMailField.label
                      )
                    : this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                        mobileNumberField.label
                      )
                }
                type={
                  this.queryParams.arcades === KOLKATA_BHOWANIPORE
                    ? 'text'
                    : 'number'
                }
                isMobile={false}
                innerRef={this.storeMdDesktopMobileNumberRef}
                label={
                  this.queryParams.arcades === KOLKATA_BHOWANIPORE
                    ? mobileNumberOrEMailField.label
                    : mobileNumberField.label
                }
                placeholder={
                  this.queryParams.arcades === KOLKATA_BHOWANIPORE
                    ? mobileNumberOrEMailField.placeholderText
                    : mobileNumberField.placeholderText
                }
                icon={IcSmartPhone}
                iconStyle={styles.phoneIcon}
                validate={
                  this.queryParams.arcades === KOLKATA_BHOWANIPORE
                    ? validateEmailOrMobileNumber
                    : validateMobileNumber
                }
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              <Separator
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              <FormDropdown
                id={NO_OF_PEOPLE}
                ref={this.captureMdDesktopDropdownRef}
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              <Separator
                isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
              />
              {this.isBhowaniporePresentInQueryParams() && (
                <FormDropdown
                  id={NO_OF_PEOPLE}
                  ref={this.captureMdDesktopPackageDropdownRef}
                  dropdownOptions={dropDownValues}
                  dropdownLabel={label}
                  isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                />
              )}
              {this.isBhowaniporePresentInQueryParams() && (
                <Separator
                  isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                />
              )}
              <DateField
                id={PREFERRED_DATE}
                ref={this.captureMdDesktopDateRef}
                dateConstants={dateField}
                isMobile={false}
                excludeDates={excludeDates}
              />
            </FormMdContainer>
            <Divider />
            <Divider />
            <SubmitButton
              id={BOOK_NOW_BUTTON}
              onClick={() =>
                this.handleSubmitFn(
                  this.mdDesktopDateField,
                  this.mdDesktopNameRef,
                  this.mdDesktopMobileNumberRef,
                  this.mdDesktopDropdownRef,
                  this.mdDesktopPackageDropdownRef
                )
              }
            >
              <ButtonContainer>
                <ButtonLabel>
                  <LabelText>{submitBtnText}</LabelText>
                  <ArrowIcon />
                </ButtonLabel>

                <ButtonText as="p">
                  You can avail offers/discounts while making the payment at our
                  arcade.
                </ButtonText>
              </ButtonContainer>
            </SubmitButton>
            <TermsAndConditionsModal
              handleCloseModal={this.closeTnCModal}
              ref={this.captureTnCModalRef}
            >
              <TnCContainer>
                <IconContainer onClick={this.closeTnCModal}>
                  <IcClose
                    strokeColor={Colors.lightGrey}
                    width={iconWidth}
                    height={iconHeight}
                  />
                </IconContainer>
                <TermsAndConditions
                  termsAndConditionsData={termsAndConditionsData}
                />
              </TnCContainer>
            </TermsAndConditionsModal>
          </MainMdContainer>
          {this.renderTermsAndConditions()}
        </MdDesktop>
      )
    )
  }

  renderDesktopOrMdDesktopOrMobile = () => {
    const { formConstants, excludeDates } = this.props
    const {
      dateField,
      submitBtnText,
      nameField,
      mobileNumberField,
      mobileNumberOrEMailField,
      packageField
    } = formConstants
    const { dropDownValues, label } = packageField

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
      if (this.state.parsedQueryParams === false)
        this.setState({ parsedQueryParams: true })
    }
    return (
      this.state.parsedQueryParams && (
        <PunePageResponsiveContainer>
          <Desktop>
            <MainContainer id="slot-booking-main-container">
              <FormContainer id="slot-booking-form-container">
                <InputContainer
                  id={this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                    nameField.label
                  )}
                  isMobile={false}
                  innerRef={this.storeDesktopFullNameRef}
                  label={nameField.label}
                  placeholder={nameField.placeholderText}
                  icon={IcUser}
                  validate={validateFullName}
                  isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                />
                <InputContainer
                  id={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                          mobileNumberOrEMailField.label
                        )
                      : this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                          mobileNumberField.label
                        )
                  }
                  type={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? 'text'
                      : 'number'
                  }
                  isMobile={false}
                  innerRef={this.storeDesktopMobileNumberRef}
                  label={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? mobileNumberOrEMailField.label
                      : mobileNumberField.label
                  }
                  placeholder={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? mobileNumberOrEMailField.placeholderText
                      : mobileNumberField.placeholderText
                  }
                  icon={IcSmartPhone}
                  iconStyle={styles.phoneIcon}
                  validate={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? validateEmailOrMobileNumber
                      : validateMobileNumber
                  }
                  isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                />
                <FormDropdown
                  id={NO_OF_PEOPLE}
                  ref={this.captureDesktopDropdownRef}
                  isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                />
                {this.isBhowaniporePresentInQueryParams() && (
                  <FormDropdown
                    id={NO_OF_PEOPLE}
                    ref={this.capturePackageDesktopDropdownRef}
                    dropdownOptions={dropDownValues}
                    dropdownLabel={label}
                    isBhowaniporePresentInQueryParams={this.isBhowaniporePresentInQueryParams()}
                  />
                )}
                <DateField
                  id={PREFERRED_DATE}
                  ref={this.captureDesktopDateRef}
                  dateConstants={dateField}
                  isMobile={false}
                  excludeDates={excludeDates}
                />
              </FormContainer>
              <SubmitButton
                id={BOOK_NOW_BUTTON}
                onClick={() =>
                  this.handleSubmitFn(
                    this.desktopDateField,
                    this.desktopNameRef,
                    this.desktopMobileNumberRef,
                    this.desktopDropdownRef,
                    this.desktopPackageDropdownRef
                  )
                }
              >
                <ButtonContainer>
                  <ButtonLabel>
                    <LabelText>{submitBtnText}</LabelText>
                    <ArrowIcon />
                  </ButtonLabel>

                  <ButtonText as="p">
                    You can avail offers/discounts while making the payment at
                    our arcade.
                  </ButtonText>
                </ButtonContainer>
              </SubmitButton>
            </MainContainer>
            {this.renderTermsAndConditions()}
          </Desktop>
          {this.renderMdDesktop()}
          <Mobile>
            <BaseModalContainer
              ref={this.captureModalRef}
              style={styles}
              hideCloseIcon
            >
              <FormMobileMainContainer>
                <CloseIconWrapper onClick={this.closeModal}>
                  <CloseModalIcon />
                </CloseIconWrapper>
                <InputContainer
                  isMobile
                  innerRef={this.storeFullNameRef}
                  label={nameField.label}
                  id={this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                    nameField.label
                  )}
                  placeholder={nameField.placeholderText}
                  icon={IcUser}
                  validate={validateFullName}
                />
                <Divider />
                <InputContainer
                  type={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? 'text'
                      : 'number'
                  }
                  isMobile
                  innerRef={this.storeMobileNumberRef}
                  label={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? mobileNumberOrEMailField.label
                      : mobileNumberField.label
                  }
                  id={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                          mobileNumberOrEMailField.label
                        )
                      : this.replaceSpacesAndHypensInStringAndConvertToLowerCase(
                          mobileNumberField.label
                        )
                  }
                  placeholder={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? mobileNumberOrEMailField.placeholderText
                      : mobileNumberField.placeholderText
                  }
                  icon={IcSmartPhone}
                  iconStyle={styles.phoneIcon}
                  validate={
                    this.queryParams.arcades === KOLKATA_BHOWANIPORE
                      ? validateEmailOrMobileNumber
                      : validateMobileNumber
                  }
                />
                <Divider />
                <FormDropdown
                  isMobile
                  ref={this.captureDropdownRef}
                  id={NO_OF_PEOPLE}
                />
                <Divider />
                {this.isBhowaniporePresentInQueryParams() && (
                  <FormDropdown
                    isMobile
                    ref={this.capturePackageDropdownRef}
                    dropdownOptions={dropDownValues}
                    dropdownLabel={label}
                    id={NO_OF_PEOPLE}
                  />
                )}
                <Divider />
                <DateField
                  ref={this.captureDateRef}
                  dateConstants={dateField}
                  isMobile
                  excludeDates={excludeDates}
                  id={PREFERRED_DATE}
                />
                <Divider />
                <Divider />
                <SubmitBtnContainer
                  id={BOOK_NOW_BUTTON}
                  onClick={() =>
                    this.handleSubmitFn(
                      this.dateField,
                      this.usernameRef,
                      this.mobileNumberRef,
                      this.dropdownRef,
                      this.packageDropdownRef
                    )
                  }
                >
                  <ButtonWrapper>
                    {submitBtnText}
                    <ButtonIconContainer>
                      <ArrowIcon />
                    </ButtonIconContainer>
                  </ButtonWrapper>
                </SubmitBtnContainer>
                {this.renderTermsAndConditions()}
              </FormMobileMainContainer>
            </BaseModalContainer>
          </Mobile>
        </PunePageResponsiveContainer>
      )
    )
  }
  render() {
    return this.renderDesktopOrMdDesktopOrMobile()
  }
}

export default FormHomePage



// WEBPACK FOOTER //
// ./src/components/FormHomePage/index.js